import { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import logo from "../assets/logo.png";
import { t } from "../translations";

import "./styles/404.css";

const UnderMaintenance = () => {
  const history = useHistory();
  const selectedLang = useSelector((state) => state.lang);
  const [countdown, setCountdown] = useState(30);
  const [autoRefresh, setAutoRefresh] = useState(true);

  const handleRefresh = useCallback(() => {
    // ✅ Option 1: Navigate to home (recommended)
    history.push("/");

    // ✅ Option 2: Refresh current route
    // history.push(history.location.pathname);
  }, [history]);

  // Auto-refresh countdown
  useEffect(() => {
    if (!autoRefresh) return;

    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          handleRefresh();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [autoRefresh, handleRefresh]);

  return (
    <div
      style={{
        height: "100vh",
        backgroundColor: "#fff"
      }}
    >
      <div
        className="container"
        style={{
          height: "85vh",
          backgroundColor: "#fff"
        }}
      >
        <div className="row">
          <div className="col-sm-12 ">
            <div className="col-sm-10 col-sm-offset-1  text-center">
              <img
                src={logo}
                style={{
                  width: 100
                }}
                alt="under-maintenance"
              />

              <div
                className="contant_box_404"
                style={{
                  marginTop: 20
                }}
              >
                <h1
                  style={{
                    fontSize: 40
                  }}
                >
                  {t("maintenance.title", selectedLang)}
                </h1>

                <h1>{t("maintenance.subtitle", selectedLang)}</h1>

                {/* ✅ Better - Use button instead of anchor tag */}
                <button
                  className="link_404"
                  onClick={handleRefresh}
                  style={{
                    background: "none",
                    border: "none",
                    cursor: "pointer",
                    textDecoration: "underline",
                    color: "inherit",
                    fontSize: "inherit",
                    fontFamily: "inherit"
                  }}
                >
                  {t("maintenance.refresh_button", selectedLang)}
                </button>

                <br />

                {/* ✅ Auto-refresh with timer */}
                {autoRefresh && (
                  <div
                    style={{
                      marginTop: "20px",
                      fontSize: "14px",
                      color: "#666"
                    }}
                  >
                    {t("maintenance.auto_refresh", selectedLang)}:{" "}
                    <span style={{ fontWeight: "bold", color: "#ff114d" }}>
                      {countdown}
                    </span>
                    s
                    <br />
                    <button
                      onClick={() => setAutoRefresh(false)}
                      style={{
                        background: "none",
                        border: "none",
                        color: "#666",
                        textDecoration: "underline",
                        cursor: "pointer",
                        fontSize: "12px",
                        marginTop: "5px"
                      }}
                    >
                      {t("maintenance.cancel", selectedLang)}
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UnderMaintenance;
